import { getEnvConfig } from "../../apiConfig/urlConfig/envConfig";

export const redirectToGrowXLogout = () => {
  const { RedirectBaseURL, LogoutUrl } = getEnvConfig();

  const redirectUri = `${window.location.origin}/`;

  const logoutUrl =
    `${RedirectBaseURL}${LogoutUrl}` +
    `?redirectUri=${encodeURIComponent(redirectUri)}`;

  window.location.href = logoutUrl;
};